import React, { Component } from "react";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout.js";
import Head from "next/head";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

import { resizeImage } from "@lib/helpers";

import { trackProduct } from "@store/tracker/actions";
import { getProduct } from "@store/catalog/actions";
import { getCmsBlocks, getWebsiteAdminConfig } from "@store/app/actions";

import CatalogView from "@containers/Catalog/View";
import ErrorPage from "@containers/ErrorPage";
import ProductSchema from "@components/ProductSchema";
import PromoToasts from "@components/PromoToasts";
import { getStores } from "@store/stores/actions";
import PAGE_NAMES from "@lib/pageNames";

class View extends Component {
  static async getInitialProps(ctx) {
    const { reduxStore, query, res, asPath: urlAsPath } = ctx;

    const stores = reduxStore.getState().stores.data;

    if (query.productSku) {
      const product = await reduxStore.dispatch(
        getProduct(encodeURIComponent(query.productSku))
      );

      if (!product && res) {
        res.statusCode = 404;
      }
    }

    if (!reduxStore.getState().app.websiteAdminConfigs.featureFlags) {
      await reduxStore.dispatch(
        getWebsiteAdminConfig({ code: "featureFlagsWebsite" })
      );
    }

    await reduxStore.dispatch(getCmsBlocks(["altex_catalog_product_services"]));

    if (!stores) {
      await reduxStore.dispatch(getStores());
    }

    return {
      urlAsPath,
      query,
    };
  }

  componentDidMount() {
    const { trackProduct, currentProduct } = this.props;

    if (currentProduct) {
      // Track product category breadcrumbs
      const productBreadcrumbs = [...currentProduct.breadcrumbs];

      // Remove product name from breadcrumbs
      productBreadcrumbs.pop();

      // Track product
      trackProduct(
        {
          ...currentProduct.product,
          categoryPath: productBreadcrumbs,
        },
        productBreadcrumbs,
        PAGE_NAMES.CATALOG_PRODUCT
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { urlAsPath, trackProduct, currentProduct } = this.props;

    // Track page query change
    if (prevProps.urlAsPath !== urlAsPath && currentProduct) {
      // Track product category breadcrumbs
      const productBreadcrumbs = [...currentProduct.breadcrumbs];

      // Remove product name from breadcrumbs
      productBreadcrumbs.pop();

      // Track product
      trackProduct(
        {
          ...currentProduct.product,
          categoryPath: productBreadcrumbs,
        },
        productBreadcrumbs,
        PAGE_NAMES.CATALOG_PRODUCT
      );
    }
  }

  render() {
    const { currentProduct } = this.props;

    if (currentProduct && currentProduct.product) {
      const {
        meta_title = "",
        meta_description = "",
        meta_keywords = "",
        meta_robots,
        seo_canonical,
        seo_alternate_canonical = "",
        name = "",
        url_key,
        sku,
      } = currentProduct.product;

      return (
        <>
          <Head>
            <title>{meta_title || name || ""}</title>

            {meta_description.length > 0 && (
              <meta name="description" content={meta_description} />
            )}

            {meta_keywords.length > 0 && (
              <meta name="keywords" content={meta_keywords} />
            )}

            {meta_robots?.length > 0 && (
              <meta name="robots" content={meta_robots} />
            )}

            {seo_canonical && !seo_alternate_canonical?.length > 0 && (
              <link
                rel="canonical"
                href={`${settings.baseUrl}/${url_key}/cpd/${sku}/`}
              />
            )}

            {seo_canonical && seo_alternate_canonical?.length > 0 && (
              <link rel="alternate" href={seo_alternate_canonical} />
            )}

            {!!currentProduct.product.image && (
              <meta
                property="og:image"
                content={resizeImage(currentProduct.product.image, "600x600")}
              />
            )}
          </Head>

          <ProductSchema productData={currentProduct} />
          <CatalogView key={currentProduct.product.sku} />

          <PromoToasts
            type="product"
            params={{ sku: currentProduct.product.sku }}
          />
        </>
      );
    }

    return <ErrorPage layout="404" />;
  }
}

View.pageLayout = "default";

export default withRouterPageLayout(
  connect(
    (state) => ({
      currentProduct: state.catalog.currentProduct,
    }),
    {
      trackProduct,
      getStores,
    }
  )(View)
);
